import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "initialScreen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_3 = { class: "avatar" }
const _hoisted_4 = { class: "participantName" }

import { ProfileAvatarSizeEnum } from "@/types/avatar";
import CallAvatar from "../CallAvatar/CallAvatar.vue";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { IOngoingCall } from "@/store/auth/types";
import { LocalVideoTrack, createLocalVideoTrack } from "twilio-video";
import { shallowRef } from "vue";
import {
  attachTrack,
  stopMediaPreview,
  togglePreviewCamera,
} from "@/utils/call";
import { config } from "@/config";

const videoPreviewId = "videoPreview";

export default /*#__PURE__*/_defineComponent({
  __name: 'InitialCallScreen',
  setup(__props) {

const { t } = useI18n();
const videoRef = ref<HTMLDivElement | null>(null);
const currentCall = useComputedValue<IOngoingCall>(
  GetterTypes.GET_CURRENT_ONGOING_CALL,
);
const participantText = computed(
  () => `${t("call.establishingCall")} ${currentCall.value.displayChatName}`,
);
const videoTrack = shallowRef<LocalVideoTrack | null>();
const hasVideo = useComputedValue<boolean>(
  GetterTypes.GET_ONGOING_CALL_HAS_VIDEO,
);

const addVideoTrack = async () => {
  const track = await createLocalVideoTrack(
    config.constants.DEFAULT_VIDEO_SETTINGS,
  );
  videoTrack.value = track;
  attachTrack(track, videoPreviewId, true);
};

onMounted(() => {
  addVideoTrack();
});

onBeforeUnmount(() => {
  removeCameraPreview();
});

const removeCameraPreview = async () => {
  if (!videoTrack.value) {
    return;
  }

  stopMediaPreview(videoTrack.value);
  videoTrack.value = null;
};

watch(hasVideo, () => {
  if (!videoTrack.value) {
    return;
  }
  togglePreviewCamera(videoTrack.value, videoPreviewId, hasVideo.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: videoPreviewId,
      ref_key: "videoRef",
      ref: videoRef,
      class: "videoRef tracks"
    }, null, 512),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CallAvatar, {
        size: _unref(ProfileAvatarSizeEnum).ExtraBig,
        src: _unref(currentCall).displayChatPicture,
        "is-connected": false
      }, null, 8, ["size", "src"]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(participantText.value), 1)
    ])
  ]))
}
}

})